import {useEffect} from 'react'

import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import DeleteAccount from './DeleteAccount'
import EmailManagement from './EmailManagement'
import Loader from '../../shared/Loader'
import PasswordSettings from './PasswordSettings'

import {connect} from '../../../state/hooks/tools'
import {readEndpoint} from '../../../lib/asyncMethods'
import {EMAILS, PASSWORDS} from '../../../state/actionTypes'
import {isEmpty} from '../../../lib/tools'

import './accountSettingsController.scss'

const AccountSettingsController = props => {
  useEffect(() => {
    if (isEmpty(props.emails))
      props.fetchEmails('emails')

    if (isEmpty(props.passwords))
      props.fetchPasswords('passwords')
  }, [])

  return (
    <Loader loading={props.isLoading}>
      <Stack className='account-settings-controller'>
        <Typography variant='h5' gutterBottom>Account Settings</Typography>
        <Divider />
        <EmailManagement />
        <PasswordSettings />
        <DeleteAccount />
      </Stack>
    </Loader>
  )
}

const mapStateToProps = ({emails, passwords}) => ({
  emails: [],
  passwords: [],
  ...emails,
  ...passwords,
  isLoading: isEmpty(emails.emails) || isEmpty(passwords.passwords)
})

const actionCreators = ({emails, passwords}) => ({
  fetchEmails: readEndpoint(emails, EMAILS),
  fetchPasswords: readEndpoint(passwords, PASSWORDS)
})

export default connect(mapStateToProps, actionCreators)(AccountSettingsController)
